export default {
    BASE_URL: '/pc/crm/consultation',
    api: [
      {
        name: 'consultationStatusIdLabel',
        desc: '获取咨询状态下拉框',
        method: 'GET',
        path: '/consultationStatusIdLabel'
      },
      {
        name: 'statusIdLabel',
        desc: '获取回复情况下拉框',
        method: 'GET',
        path: '/statusIdLabel'
      },
      {
        name: 'list',
        desc: '获取我要咨询数据列表',
        method: 'GET',
        path: '/list'
      },
      {
        name: 'detail',
        desc: '获取我要咨询查看详情',
        method: 'GET',
        path: '/detail'
      },
      {
        name: 'replay',
        desc: '咨询回复',
        method: 'POST',
        path: '/replay'
      },
      {
        name: 'changeStatus',
        desc: '更改状态',
        method: 'POST',
        path: '/changeStatus'
      }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/business/consultservice.js